import { patchUserProfile } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { createDobFieldValidation, useUpdateSettingsHandlers } from '@uplift/ui-v2';
import * as Yup from 'yup';
import { SettingsData } from '../../../hooks/use-settings-data.hook';

export type DobFormType = {
  dob: string | null;
};

export const useDobForm = (userId: string, data: SettingsData) => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettingsHandlers(userId, l10n.providerSettings.dateOfBirth);

  const dobFormik = () => {
    const initialValues: DobFormType = {
      dob: data?.profile?.dob
        ? CalendarDateService.date(data.profile.dob).format(DateFormats.DEFAULT_DATE)
        : null
    };

    const validationSchema = Yup.object({
      dob: createDobFieldValidation(l10n, { adult: true }),
    });

    const onSubmit = async (values: DobFormType) => {
      try {
        await patchUserProfile(userId, {
          dateOfBirth: CalendarDateService.date(values.dob).format(DateFormats.ISO_DATE)
        });

        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { dobFormik };
};
